import { useState, useEffect } from "react"
import { useGlobalContext } from "../data/GlobalContext"

export default function VipLevel({ onClose }) {
  const { vipDetails, playerDetails } = useGlobalContext()

  const vipImages = {
    1: "/images/icon/vip/emerald-icon-unique.webp",
    2: "/images/icon/vip/sapphire-icon-unique.webp",
    3: "/images/icon/vip/ruby-icon-unique.webp",
    4: "/images/icon/vip/diamond-icon-unique.webp",
    5: "/images/icon/vip/alexandrite-icon-unique.webp",
  }

  // Convert vipLevel to a number and compute the next level
  const currentLevel = parseInt(vipDetails.vipLevel, 10) || 1
  const nextLevel = currentLevel + 1

  // Get the next level image if available; fallback to the current image if not
  const nextVipImage = vipImages[nextLevel] || vipImages[currentLevel]

  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <div className="openProfileItems-container">
      {windowWidth <= 840 && (
        <div className="close-profile-module-container">
          <div className="profile-logo">
            <a href="/">
              <img src="/images/icon/fgh-logo.webp" alt="FGH Logo" />
            </a>
          </div>
          <button className="close-profile-module-btn" onClick={onClose}>
            <img src="/images/icon/ARROW.webp" alt="" /> Back
          </button>
        </div>
      )}
      <div className="openVip">
        <div className="openProfile-Label">VIP Level</div>
        <div className="profile-vip-container">
          <div className="profile-vip-current-level">
            <div className="profile-vip-label">Current Vip Level</div>
            <div className="profile-vip-level-container">
              <img
                className="profile-vip-active"
                srcSet={vipImages[currentLevel]}
                alt={vipDetails.vipName}
              />
              <div>{playerDetails.playername}</div>
              <div className="profile-vip-requirements-container">
                <div className="profile-vip-maintain">
                  <label>Deposit to Maintain : </label>
                  <div>
                    <strong>
                      {vipDetails.vipDepositToRetain || "Preparing..."}
                    </strong>
                  </div>
                </div>
                <div className="profile-vip-maintain">
                  <label>Turnover to Maintain : </label>
                  <div>
                    <strong>
                      {vipDetails.vipTurnoverToRetain || "Preparing..."}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="profile-vip-next-level">
            <div className="profile-vip-label">Next Level Requirement</div>
            <div className="profile-vip-level-container">
              <img
                srcSet={nextVipImage}
                alt={`VIP Level ${nextLevel}`}
                className="profile-vip-next-level-img"
              />
              {currentLevel === 5 ? (
                <span>You are already at max level</span>
              ) : (
                <>
                  <div className="profile-vip-requirements-container">
                    <span>
                      <label>Deposit to Next Lvl : </label>
                      {vipDetails.vipDepositToNextLevel || "Preparing..."}
                    </span>
                    <span>
                      <label>Turnover to Next Lvl : </label>
                      {vipDetails.vipTurnoverToNextLevel || "Preparing..."}
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="profile-vip-disclaimer-message">
          <p>
            You are on your way to the next level with more
            <strong> VIP BENEFITS</strong> at FGH! Play regularly to level up!
          </p>
          <p>
            Click <a href="/vip/">HERE</a> to check on our latest{" "}
            <strong> VIP BENEFITS </strong>
            you could enjoy!
          </p>
        </div>
      </div>
    </div>
  )
}
